import { useEffect, useState } from "react";

export default function usePageReady(apiLoaded) {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [fiveSecComplete, setFiveSecComplete] = useState(false);

  // 5 second fixed splash
  useEffect(() => {
    const t = setTimeout(() => setFiveSecComplete(true), 5000);
    return () => clearTimeout(t);
  }, []);

  // Check when all images are loaded
  useEffect(() => {
    const imgs = Array.from(document.images);
    if (imgs.length === 0) {
      setImagesLoaded(true);
      return;
    }

    let loadedCount = 0;

    imgs.forEach((img) => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.onload = img.onerror = () => {
          loadedCount++;
          if (loadedCount === imgs.length) {
            setImagesLoaded(true);
          }
        };
      }
    });
  }, []);

  return fiveSecComplete && apiLoaded && imagesLoaded;
}
